var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7a934f",
    d: "M7.963 2.624a.538.538 0 0 0 0 .75L13.445 9l-5.482 5.622a.538.538 0 0 0 .168.866.513.513 0 0 0 .566-.114l5.83-5.982a.562.562 0 0 0 0-.785l-5.83-5.982a.512.512 0 0 0-.734 0zm-4.5 0a.538.538 0 0 0 0 .75L8.945 9l-5.482 5.622a.538.538 0 0 0 .168.866.513.513 0 0 0 .566-.114l5.83-5.982a.563.563 0 0 0 0-.785l-5.83-5.982a.512.512 0 0 0-.734 0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/Arrows.b8e0f9dd951203c2d98d7b8df827fa0b.svg";
export { ForwardRef as ReactComponent };